import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontWeights,
  palette,
  spaceMin,
  breakpoints,
  halfWidth,
  sizeH2,
}: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: spaceMin,
    [breakpoints.up('lg')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
    },
  },
  vertical: {
    [breakpoints.up('lg')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      gap: '2.5rem',
    },
  },
  title: {
    margin: 0,
    color: palette.primary.dark,
    fontSize: '2.375rem',
    lineHeight: 1.2,
    fontWeight: fontWeights.regular,
    letterSpacing: -0.56,
    [breakpoints.up('md')]: {
      fontSize: sizeH2,
    },
    [breakpoints.up('lg')]: {
      flexBasis: `calc(${halfWidth})`,
    },
  },
  light: {
    '&&': {
      color: palette.primary.light,
    },
  },
  content: {
    margin: 0,
    color: palette.primary.dark,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    [breakpoints.up('lg')]: {
      flexBasis: `calc(${halfWidth})`,
      width: `calc(${halfWidth})`,
    },
  },
  color: {
    color: palette.primary.main,
  },
  block: {
    display: 'block',
  },
  fullWidth: {
    [breakpoints.up('lg')]: {
      flexBasis: '100%',
    },
  },
  newLine: {
    display: 'block',
  },
}));
